import React from 'react';
import styled from 'styled-components';

// Components
import Button from '../../Button/Button';

const DeletePresetSuccess = ({
  setOpenModal
}) => {
  return (
    <Container>
      <ActionContainer>
        <Button 
          size="lg"
          onClick={() => setOpenModal(false)}>
          Okay
        </Button>
      </ActionContainer>
    </Container>
  );
};

export default DeletePresetSuccess;

const Container = styled.div`

`

const ActionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 36px;
`